<template>
  <el-dialog :append-to-body="true" title="修改名称" :visible.sync="dialogVisible" width="506px" :show-close="true" :center="true">
    <div class="reset-tip">印章名称（最长10个字符）</div>
    <el-form @submit.native.prevent :model="sealForm" label-width="0" :rules="sealRules" ref="sealForm" class="seal-Form">
      <el-form-item prop="sealName">
        <el-input v-model="sealForm.sealName" maxlength="10" placeholder="请输入印章名称"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-btns clearfix">
      <el-button type="primary" :disabled="clickReset" @click="submitHandle" class="btn-ok">确认</el-button>
      <el-button type="info" @click="cancel" style="float: right;" class="btn-cancel">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { ressetSealNameApi } from '@/api/space/signatures'
export default {
  props: ['sealId'],
  data() {
    return {
      dialogVisible: false,
      clickReset: false,
      sealForm: {
        sealName: ''
      },
      sealRules: {
        sealName: [
          { required: true, message: '签章名不能为空！', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitHandle() {
      this.$refs.sealForm.validate((valid) => {
        if (valid) {
          this.clickReset = true
          ressetSealNameApi({
            sealId: this.sealId,
            sealName: this.sealForm.sealName
          }).then(res => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'warning'
              });
              this.clickReset = false
            } else {
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              });
              this.$parent.init()
              this.cancel()
              this.clickReset = false
            }
          })
        } else {
          return false
        }
      })
    },
    cancel() {
      this.sealForm.sealName = ''
      this.dialogVisible = false
    }
  }
}
</script>
<style scoped>
  .reset-tip{
    width: 400px;
    font-size: 16px;
    color: #333333;
    margin: 0 auto;
  }

  .seal-Form{
    width: 400px;
    margin: 20px auto 0;
  }

  .dialog-btns{
    width: 400px;
    margin: 66px auto 0;
    overflow: hidden;
  }

  .dialog-btns button {
    display: block;
    width: 179px;
    height: 50px;
    font-size: 18px;
    border-radius: 10px;
    float: left;
  }
</style>